<!--
    描述： 六算分析表 -- 表格模块
    时间： xx
    created by ws
-->
<template>
    <div class="w-table-layout">
        <div class="w-table-content bd-table"
             ref="tableContent">
            <el-table class="w100 h100"
                      :height="tableH"
                      ref="xTable"
                      border
                      highlight-current-row
                      :data="tableData"
                      v-loading="loading"
                      row-key="id"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                      :header-cell-style="headerCellStyle"
                      :cell-style="cellStyle"
                      :expand-row-keys="expandKeys"
                      :row-class-name="rowClassName"
                      :cell-class-name="cellClassName">
                <el-table-column type="index"
                                 label="序号"
                                 align="center"
                                 width="50">
                </el-table-column>
                <el-table-column prop="sname"
                                 label="信息名称"
                                 header-align="center"
                                 align="left"
                                 show-overflow-tooltip
                                 min-width="200">
                    <template v-slot="{ row }">
                        {{ row.sname }}
                        <el-tooltip placement="right"
                                    effect="light"
                                    v-if="row.tags !== '' && row.levelType !== 2">
                            <div slot="content"
                                    class="tag-label-tooltip">
                                <el-tag class="mr10 mb10"
                                        size="mini"
                                        v-for="(item, index) in toArray(row.tags)"
                                        :key="index">{{ item }}</el-tag>
                            </div>
                            <svg-icon icon-class="biaoqian"
                                        class="ml5"></svg-icon>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="header.estimateMoney"
                                 align="center"
                                 min-width="130">
                    <template slot="header"
                              slot-scope="scope">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="设置基准值"
                                    placement="bottom">
                            <el-radio v-model="chooseName" class="whiteText" label="estimateMoney">概算价</el-radio>
                        </el-tooltip>
                    </template>
                    <el-table-column label="金额"
                                     prop="estimateMoney"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="110">
                        <template slot-scope="scope">
                            <el-tooltip placement="right"
                                        v-if="parseFloat(getSum(scope.row.children, 'estimateMoney')) !== parseFloat(scope.row.estimateMoney) && scope.row.children">
                                <div slot="content">
                                    <p>{{ `合计额：${getSum(scope.row.children, 'estimateMoney')}元` }}</p>
                                    <p>{{ `合价××文件调整金额：${scope.row.estimateMoney}元` }}</p>
                                </div>
                                <div>{{ scope.row.estimateMoney }}</div>
                            </el-tooltip>
                            <div v-else>{{ scope.row.estimateMoney }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="内部占比"
                                     prop="estimateMoney.inner"
                                     header-align="center"
                                     align="right"
                                     width="90">
                        <template slot-scope="scope">
                            {{ getInnerPercent(scope.row, 'estimateMoney') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="纵向对比"
                                     prop="estimateMoney.out"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="90">
                        <template slot-scope="scope">
                            {{ getOutPercent(scope.row, 'estimateMoney') }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="header.controlMoney"
                                 header-align="center"
                                 min-width="120">
                    <template slot="header"
                              slot-scope="scope">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="设置基准值"
                                    placement="bottom">
                            <el-radio v-model="chooseName" class="whiteText"
                                      label="controlMoney">{{ `控制价`}}
                            </el-radio>
                        </el-tooltip>
                    </template>
                    <el-table-column label="金额"
                                     prop="controlMoney"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="110">
                        <template slot-scope="scope">
                            <el-tooltip placement="right"
                                        v-if="parseFloat(getSum(scope.row.children, 'controlMoney')) !== parseFloat(scope.row.controlMoney) && scope.row.children">
                                <div slot="content">
                                    <p>{{ `合计额：${getSum(scope.row.children, 'controlMoney')}元` }}</p>
                                    <p>{{ `合价××文件调整金额：${scope.row.controlMoney}元` }}</p>
                                </div>
                                <div>{{ scope.row.controlMoney }}</div>
                            </el-tooltip>
                            <div v-else>{{ scope.row.controlMoney }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="内部占比"
                                     prop="controlMoney.inner"
                                     header-align="center"
                                     align="right"
                                     width="90">
                        <template slot-scope="scope">
                            {{ getInnerPercent(scope.row, 'controlMoney') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="纵向对比"
                                     prop="controlMoney.out"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="90">
                        <template slot-scope="scope">
                            {{ getOutPercent(scope.row, 'controlMoney') }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="header.biddingMoney"
                                 header-align="center"
                                 min-width="120">
                    <template slot="header"
                              slot-scope="scope">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="设置基准值"
                                    placement="bottom">
                            <el-radio v-model="chooseName" class="whiteText"
                                      label="biddingMoney">{{ `中标价`}}
                            </el-radio>
                        </el-tooltip>
                    </template>
                    <el-table-column label="金额"
                                     prop="biddingMoney"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="110">
                        <template slot-scope="scope">
                            <el-tooltip placement="right"
                                        v-if="parseFloat(getSum(scope.row.children, 'biddingMoney')) !== parseFloat(scope.row.biddingMoney) && scope.row.children">
                                <div slot="content">
                                    <p>{{ `合计额：${getSum(scope.row.children, 'biddingMoney')}元` }}</p>
                                    <p>{{ `合价××文件调整金额：${scope.row.biddingMoney}元` }}</p>
                                </div>
                                <div>{{ scope.row.biddingMoney }}</div>
                            </el-tooltip>
                            <div v-else>{{ scope.row.biddingMoney }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="内部占比"
                                     prop="biddingMoney.inner"
                                     header-align="center"
                                     align="right"
                                     width="90">
                        <template slot-scope="scope">
                            {{ getInnerPercent(scope.row, 'biddingMoney') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="纵向对比"
                                     prop="biddingMoney.out"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="90">
                        <template slot-scope="scope">
                            {{ getOutPercent(scope.row, 'biddingMoney') }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="header.reportMoney"
                                 header-align="center"
                                 min-width="120">
                    <template slot="header"
                              slot-scope="scope">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="设置基准值"
                                    placement="bottom">
                            <el-radio v-model="chooseName" class="whiteText"
                                      label="reportMoney">{{ `报审价`}}
                            </el-radio>
                        </el-tooltip>
                    </template>
                    <el-table-column label="金额"
                                     prop="reportMoney"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="110">
                        <template slot-scope="scope">
                            <el-tooltip placement="right"
                                        v-if="parseFloat(getSum(scope.row.children, 'reportMoney')) !== parseFloat(scope.row.reportMoney) && scope.row.children">
                                <div slot="content">
                                    <p>{{ `合计额：${getSum(scope.row.children, 'reportMoney')}元` }}</p>
                                    <p>{{ `合价××文件调整金额：${scope.row.reportMoney}元` }}</p>
                                </div>
                                <div>{{ scope.row.reportMoney }}</div>
                            </el-tooltip>
                            <div v-else>{{ scope.row.reportMoney }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="内部占比"
                                     prop="reportMoney.inner"
                                     header-align="center"
                                     align="right"
                                     width="90">
                        <template slot-scope="scope">
                            {{ getInnerPercent(scope.row, 'reportMoney') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="纵向对比"
                                     prop="reportMoney.out"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="90">
                        <template slot-scope="scope">
                            {{ getOutPercent(scope.row, 'reportMoney') }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="header.beforeMoney"
                                 header-align="center"
                                 min-width="120">
                    <template slot="header"
                              slot-scope="scope">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="设置基准值"
                                    placement="bottom">
                            <el-radio v-model="chooseName" class="whiteText"
                                      label="beforeMoney">{{ `初审价`}}
                            </el-radio>
                        </el-tooltip>
                    </template>
                    <el-table-column label="金额"
                                     prop="beforeMoney"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="110">
                        <template slot-scope="scope">
                            <el-tooltip placement="right"
                                        v-if="parseFloat(getSum(scope.row.children, 'beforeMoney')) !== parseFloat(scope.row.beforeMoney) && scope.row.children">
                                <div slot="content">
                                    <p>{{ `合计额：${getSum(scope.row.children, 'beforeMoney')}元` }}</p>
                                    <p>{{ `合价××文件调整金额：${scope.row.beforeMoney}元` }}</p>
                                </div>
                                <div>{{ scope.row.beforeMoney }}</div>
                            </el-tooltip>
                            <div v-else>{{ scope.row.beforeMoney }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="内部占比"
                                     prop="beforeMoney.inner"
                                     header-align="center"
                                     align="right"
                                     width="90">
                        <template slot-scope="scope">
                            {{ getInnerPercent(scope.row, 'beforeMoney') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="纵向对比"
                                     prop="beforeMoney.out"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="90">
                        <template slot-scope="scope">
                            {{ getOutPercent(scope.row, 'beforeMoney') }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="header.afterMoney"
                                 header-align="center"
                                 min-width="120">
                    <template slot="header"
                              slot-scope="scope">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="设置基准值"
                                    placement="bottom">
                            <el-radio v-model="chooseName" class="whiteText"
                                      label="afterMoney">{{ `审定价`}}
                            </el-radio>
                        </el-tooltip>
                    </template>
                    <el-table-column label="金额"
                                     prop="afterMoney"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="110">
                        <template slot-scope="scope">
                            <el-tooltip placement="right"
                                        v-if="parseFloat(getSum(scope.row.children, 'afterMoney')) !== parseFloat(scope.row.afterMoney) && scope.row.children">
                                <div slot="content">
                                    <p>{{ `合计额：${getSum(scope.row.children, 'afterMoney')}元` }}</p>
                                    <p>{{ `合价××文件调整金额：${scope.row.afterMoney}元` }}</p>
                                </div>
                                <div>{{ scope.row.afterMoney }}</div>
                            </el-tooltip>
                            <div v-else>{{ scope.row.afterMoney }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="内部占比"
                                     prop="afterMoney.inner"
                                     header-align="center"
                                     align="right"
                                     width="90">
                        <template slot-scope="scope">
                            {{ getInnerPercent(scope.row, 'afterMoney') }}
                        </template>
                    </el-table-column>
                    <el-table-column label="纵向对比"
                                     prop="afterMoney.out"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip
                                     width="90">
                        <template slot-scope="scope">
                            {{ getOutPercent(scope.row, 'afterMoney') }}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {getSheetAnalysis} from '@/api/modules/analysisCharts'

    export default {
        name: 'analysis-sheet-list',
        data() {
            return {
                tableH: 100,
                tableData: [],
                expandKeys: [], // 初始默认展开的key 值数组
                loading: false,
                chooseName: 'estimateMoney',
            }
        },
        methods: {
            // 重新设置表格高度
            setTableH() {
                this.tableH = this.$refs.tableContent.offsetHeight
            },

            // 默认key 值展开
            expandLevel(arr, level, backArr) {
                if (arr.length > 0) {
                    arr.forEach(x => {
                        if (x.children && x.levelType < level) {
                            backArr.push(x.id)
                            this.expandLevel(x.children, level, backArr)
                        }
                    })
                }
            },

            // 行样式
            rowClassName({row, rowIndex}) {
                if (row.levelType === 0) {
                    return 'project-row'
                } else if (row.levelType === 1) {
                    return 'single-row'
                } else if (row.levelType === 2) {
                    return 'unit-row'
                }
                return ''
            },

            // 列样式--类名
            cellClassName({row, column, rowIndex}) {
                // console.log(column.property)
                if (column.property === 'estimateMoney') {
                    return 'project-ceil'
                } else if (column.property === 1) {
                    return 'single-ceil'
                } else if (column.property === 2) {
                    return 'unit-ceil'
                }
                return ''
            },
            // 列样式
            cellStyle({row, column, rowIndex, columnIndex}) {
                let style = {}
                if (column.property === this.chooseName) {
                    style = {
                        color: '#00469d',
                        fontWeight: 700,
                        borderLeft: '1px solid #085694'
                    }
                }

                if (column.property === `${this.chooseName}.inner`) {
                    style = {color: '#00469d', fontWeight: 700}
                }

                if (column.property === `${this.chooseName}.out`) {
                    style = {
                        color: '#00469d',
                        fontWeight: 700,
                        borderRight: '1px solid #085694'
                    }
                }
                return style
            },
            // 表头列样式
            headerCellStyle({row, column, rowIndex, columnIndex}) {
                if (
                    column.property === `header.${this.chooseName}` ||
                    column.property === this.chooseName ||
                    column.property === `${this.chooseName}.inner` ||
                    column.property === `${this.chooseName}.out`
                ) {
                    return {backgroundColor: '#e2d192'}
                }
            },

            // 获取内部占比
            getInnerPercent(row, attr) {
                if (row.levelType === 0) {
                    return '100.00 %'
                } else {
                    // 以根节点数据为 分母项
                    let _data = this.tableData[0]
                    let _baseNum = 0
                    let _nowNum = 0
                    if (typeof _data[attr] !== 'undefined') {
                        if (_data[attr]) {
                            _baseNum = parseFloat(_data[attr])
                        }
                    }
                    if (typeof row[attr] !== 'undefined') {
                        if (row[attr]) {
                            _nowNum = parseFloat(row[attr])
                        }
                    }

                    if (_baseNum === 0 || _nowNum === 0) {
                        return '/'
                    } else {
                        let results = ((_nowNum / _baseNum) * 100).toFixed(2)
                        return results + ' %'
                    }
                }
            },

            // 获取纵向对比
            getOutPercent(row, attr) {
                let _baseNum = 0
                let _nowNum = 0
                if (typeof row[this.chooseName] !== 'undefined') {
                    if (row[this.chooseName]) {
                        _baseNum = parseFloat(row[this.chooseName])
                    }
                }
                if (typeof row[attr] !== 'undefined') {
                    if (row[attr]) {
                        _nowNum = parseFloat(row[attr])
                    }
                }

                if (_baseNum === 0 || _nowNum === 0) {
                    return '/'
                } else {
                    let results = ((_nowNum / _baseNum) * 100).toFixed(2)
                    return results + ' %'
                }
            },

            // 主表接口
            getMainData(level) {
                this.tableData = []
                this.expandKeys = []
                this.loading = true
                getSheetAnalysis({id: this.curProjectId})
                    .then(res => {
                        this.loading = false
                        let obj = res.data.busProContract
                        obj.pid = '0'
                        obj.levelType = 0

                        if (obj.children && obj.children.length > 0) {
                            obj.children.forEach(x => {
                                x.pid = obj.id
                            })
                        }
                        // 表格数据赋值
                        this.tableData.push(res.data.busProContract)
                        // 默认展开
                        this.expandLevel(this.tableData, level, this.expandKeys)
                        this.$refs.xTable.doLayout()
                    })
                    .catch(err => {
                        this.loading = false
                    })
            },

            // 统计
            getSum(arr, type) {
                if (arr) {
                    let list = arr.map(x => x[type])
                    list = list.filter(x => x)
                    return list.sum()
                }
                return 0
            },
		
            // 展示标签
            toArray(str) {
                let arr = str.split(',').filter((x) => x !== '')
                return arr
            },
        },
        created() {
            this.getMainData(2)

            this.$nextTick(() => {
                this.tableH = this.$refs.tableContent.offsetHeight
            })
        },
        computed: {
            ...mapState('app', {
                clientSize: state => state.clientSize
            }),

            curProjectId() {
                return this.$route.query.projectId || null
            },

            // 当前造价阶段
            curPhase() {
                let arr = [
                    {
                        phase: '1007001',
                        name: 'estimateMoney'
                    },
                    {
                        phase: '1007002',
                        name: 'controlMoney'
                    },
                    {
                        phase: '1007003',
                        name: 'biddingMoney'
                    },
                    {
                        phase: '1007004',
                        name: 'reportMoney'
                    },
                    {
                        phase: '1007005',
                        name: 'beforeMoney'
                    },
                    {
                        phase: '1007006',
                        name: 'afterMoney'
                    },
                    {
                        phase: '1007001',
                        name: 'estimateMoney'
                    },
                ]

                let _item = arr.find(x => x.name === this.chooseName)
                return _item ? _item.phase : ''
            }
        },
        watch: {
            clientSize(obj) {
                this.$emit('onResize')
                this.tableH = this.$refs.tableContent.offsetHeight
            },
            // 监听项目ID 的变化
            curProjectId(val) {
                this.getMainData(2)
            }
        }
    };
</script>

<style lang="less" scoped>
.whiteText {
    color: #fff;
}
</style>
